<template>
  <div class="ds-custom-query-logic-tree">
    <DsfCustomQueryLogicNode :data="rootNode" v-if="rootNode"></DsfCustomQueryLogicNode>
  </div>
</template>
<script>
// import DsfCustomQueryLogicNode from "./customQueryLogicNode";
export default {
  name: "DsfCustomQueryLogicTree",
  provide() {
    return {
      $queryTree: this
    };
  },
  // components: {
  //   DsfCustomQueryLogicNode
  // },
  props: {
    data: {
      type: Object,
      default() {
        return {
          logic: "and",
          items: []
        };
      }
    },
    showDataType:{
      type:Boolean,
      default:false
    },
    dragProxyAppendTo:{
      type:[String,Function],
      default:""
    }
  },
  data() {
    return {
      dragStart: false
    };
  },
  computed: {
    rootNode() {
      return this?.data || null;
    }
  },
  beforeCreate() {},
  created() {
    this.resetTree();
  },
  beforeMount() {},
  mounted() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    resetTree() {
      this.updateNode();
    },
    filterInvalidNodes() {
      function fn(n) {
        if (!n.isRoot) {
          while (true) {
            if (n.isGroup && (!n.items || n.items.length == 1)) {
              n = n.items[0];
            } else {
              break;
            }
          }
        }
        if (n.isGroup) {
          let items = [];
          for (let i = 0; i < n.items.length; i++) {
            let cn = fn(n.items[i]);
            cn && items.push(cn);
          }
          n.items = items;
          if (n.items && items.length > 0) {
            return n;
          }
          return null;
        } else {
          return n;
        }
      }
      fn(this.data);
      this.buildTreeRelation();
    },
    //移除节点
    removeNode(node) {
      if (node && node.parent) {
        dsf.array.remove(node.parent.items || [], node);
        this.resetTree();
      }
    },
    updateNode() {
      this.buildTreeRelation();
      this.filterInvalidNodes();
    },
    buildTreeRelation() {
      dsf.deepForEach(
        this.data,
        (it, a, b, parent) => {
          if (it) {
            if (!("parent" in it)) {
              Object.defineProperty(it, "parent", {
                enumerable: false,
                value: parent,
                writable: true
              });
            } else {
              it.parent = parent;
            }
            this.setNode(it);
          }
        },
        { children: "items" }
      );
    },
    setNode(v) {
      if (!("$hash" in v)) {
        this.$set(v, "$hash", dsf.uuid());
      }
      this.$set(v, "isLeaf", !v.items || v.items.length <= 0);
      this.$set(v, "isGroup", dsf.isDef(v.logic));
    },
    createItemData(data) {
      let itemData = {
        dataType: "string",
        field: "",
        table: "",
        operator: "eq",
        value: null
      };
      for (let k in itemData) {
        if (dsf.isDef(data[k])) {
          itemData[k] = data[k];
        }
      }
      return itemData;
    },
    dropEnd() {
      this.dragStart = false;
    }
  },
  watch: {
    data: {
      handler(v) {
        this.$set(v, "isRoot", true);
      },
      immediate: true
    }
  }
};
</script>